import { Colors } from '@fourthwall/components';
export const getStripeCardStyle = () => ({
    base: {
        fontSize: '16px',
        color: Colors.GS1000,
        lineHeight: '24px',
        fontSmoothing: 'antialiased',
        fontFamily: '"Suisse Int\'l", sans-serif',
        backgroundColor: 'transparent',
    },
    invalid: {
        color: Colors.GS1000,
    },
});
